import { useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { 
  LayoutDashboard, 
  FileText, 
  Sparkles, 
  Home,
  Menu,
  X,
  ChevronRight
} from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_f651e4ab-7ee9-48a6-ba28-4c2cc6db2347/artifacts/te5aqtnq_FullLogo_Transparent_NoBuffer.png";

const sidebarLinks = [
  { name: "Grant Tracker", path: "/dashboard/grants", icon: FileText },
  { name: "AI Writer", path: "/dashboard/ai-writer", icon: Sparkles },
];

export const DashboardLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  return (
    <div className="min-h-screen bg-slate-50" data-testid="dashboard-layout">
      {/* Sidebar */}
      <aside 
        className={`fixed inset-y-0 left-0 z-50 w-64 dashboard-sidebar transform transition-transform duration-300 lg:translate-x-0 ${
          sidebarOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
        data-testid="dashboard-sidebar"
      >
        <div className="flex flex-col h-full">
          {/* Logo */}
          <div className="p-6 border-b border-slate-700">
            <Link to="/" className="block">
              <img 
                src={LOGO_URL} 
                alt="Millennium Wellness Spa" 
                className="h-12 w-auto object-contain brightness-110"
              />
            </Link>
          </div>

          {/* Navigation */}
          <nav className="flex-1 px-4 py-6 space-y-2">
            {sidebarLinks.map((link) => {
              const Icon = link.icon;
              const isActive = location.pathname === link.path || 
                (link.path === "/dashboard/grants" && location.pathname === "/dashboard");
              
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`sidebar-link ${isActive ? 'active' : ''}`}
                  data-testid={`sidebar-link-${link.name.toLowerCase().replace(' ', '-')}`}
                >
                  <Icon size={18} />
                  <span>{link.name}</span>
                  {isActive && <ChevronRight size={16} className="ml-auto" />}
                </Link>
              );
            })}
          </nav>

          {/* Back to Site */}
          <div className="p-4 border-t border-slate-700">
            <Link
              to="/"
              className="sidebar-link"
              data-testid="sidebar-back-to-site"
            >
              <Home size={18} />
              <span>Back to Website</span>
            </Link>
          </div>
        </div>
      </aside>

      {/* Mobile Overlay */}
      {sidebarOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Main Content */}
      <div className="lg:ml-64">
        {/* Top Bar */}
        <header className="bg-white border-b border-slate-200 sticky top-0 z-30">
          <div className="flex items-center justify-between px-6 py-4">
            <button
              className="lg:hidden p-2 -ml-2"
              onClick={() => setSidebarOpen(!sidebarOpen)}
              data-testid="dashboard-menu-toggle"
            >
              {sidebarOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
            
            <div className="flex items-center gap-4">
              <div className="text-right">
                <p className="text-sm font-medium text-[#0F172A]">Lacresha Ramos</p>
                <p className="text-xs text-slate-500">Licensed Massage Therapist</p>
              </div>
              <div className="w-10 h-10 rounded-full bg-[#D4AF37] flex items-center justify-center">
                <span className="text-[#0F172A] font-semibold">LR</span>
              </div>
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
